import {useEffect, useRef} from 'react';

/**
 * Returns a ref that is `true` while the component is mounted and `false` after unmount.
 */
export function useIsNotUnmounted(): React.MutableRefObject<boolean> {
  const isMountedRef = useRef(true);
  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef;
}
